<template>
  <div class="w-full flex flex-col gap-2">
    <progress
      class="block appearance-none border-none overflow-hidden w-full h-0.5 rounded-full text-egyptian bar-animation-carousel"
    />
  </div>
</template>

<style scoped lang="scss">
/** These styles are required to animate the bar */
progress::-webkit-progress-bar {
  @apply bg-egyptian-light;
}
progress:indeterminate {
  @apply relative;

  &:after {
    @apply content-[''];
    @apply absolute inset-0;
    @apply bg-current;
  }

  &::-webkit-progress-value {
    @apply bg-current;
  }

  &::-moz-progress-bar {
    @apply bg-current;
  }

  &.bar-animation-carousel {
    &:after {
      animation: carousel 2s ease-in-out infinite;
    }

    &::-webkit-progress-value {
      animation: carousel 2s ease-in-out infinite;
    }

    &::-moz-progress-bar {
      animation: carousel 2s ease-in-out infinite;
    }
  }
}

@keyframes carousel {
  0%,
  100% {
    width: 50%;
  }

  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(200%);
  }
}
</style>
